(() => {
  class CreateMedicationFormController {
    constructor($rootScope, $scope, $timeout, $interval, toastr, $state, ngDialog, Utils, Orders, Notifications, MedicationService) {
      'ngInject';

      Object.assign(this, {
        $scope,
        $rootScope,
        $timeout,
        $interval,
        toastr,
        $state,
        ngDialog,
        Utils,
        Orders,
        Notifications,
        MedicationService,
        visit: $scope.ngDialogData.visit // medication_name: "",

      });
      $timeout(() => {
        // angular.element(document.getElementById('createMedicationId')).focus();
        $('#createMedicationId').focus();
      }, 500);
    }

    getFilteredMedications(query) {
      return this.MedicationService.searchLemonaidMedications(this.visit.service.code, query).then(({
        data: medications
      }) => medications);
    }

    close() {
      this.$scope.closeThisDialog(null);
    }

    create() {
      if (!this.medicationQuery) {
        this.toastr.warning("Please enter medication's name.");
        return;
      }

      var payload = {
        "name": this.medicationQuery,
        // "medical_name": "Pseudolactone 50 mg",
        // "external_drug_name": "pseudolactone",
        // "dosespot_medication_id": null,
        // "default_short_directions": "Take one tablet daily by mouth for acne.",
        // "default_dispense_amount": "90",
        // "default_num_refills": 0,
        // "default_days_supply": 90,
        // "default_pharmacy_notes": "Once patient receives all of the original script (including specified refills if any), no further refills authorized until patient goes to lemonaid.com for re-eval.",
        // "default_no_substitutions": false,
        "categories": [{
          "code": this.visit.service.code,
          "product_sku_id": null
        }]
      };
      this.creating = true;
      this.MedicationService.createPimsMedication(payload).then(() => {
        this.toastr.success("PIMS medication was created successfully."); // var response = {
        //   success: true
        // }
        // this.$scope.closeThisDialog(response);

        this.$scope.closeThisDialog(null);
      }).catch(err => {
        if (err && err.data && err.data.message && err.data.message.summary) {
          this.toastr.error("Error: " + err.data.message.summary);
        } else {
          this.toastr.error(this.Notifications.generic.failure);
        }
      }).finally(() => {
        this.creating = false;
      });
    }

  }

  CreateMedicationFormController.$inject = ["$rootScope", "$scope", "$timeout", "$interval", "toastr", "$state", "ngDialog", "Utils", "Orders", "Notifications", "MedicationService"];
  angular.module('pims').controller('CreateMedicationFormController', CreateMedicationFormController);
})();